import templateStr from 'text!./templates/quote-details-box.html';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

export default [function () {
    return {
        restrict: 'A',
        scope: {
            buy: '=',
            quote: '=gwQnbQuoteDetailsBox',
            periodStart: '=',
            periodEnd: '=',
            editCoverageStep: '@?',
            lob: '@'
        },
        template: templateStr,
        controller: ['$scope', 'StateUtils', function (scope, StateUtils) {

            var ctrl = Object.create(BaseCtrl);
            var flowModel = StateUtils.activeDataForState(true).flowModel;

            ctrl.init = function () {
                if (!flowModel) {
                    return;
                }

                scope.paymentPeriod = 'fullTerm';
                scope.buyQuote = function () {
                    var termInMonths = scope.paymentPeriod === 'fullTerm' ? scope.quote.premium.termMonths : 1;
                    scope.buy(scope.quote, termInMonths);
                };
            };
            /**
             * Method used by wizard ribbon to move between steps.
             */
            ctrl.selectStep = function () {
                StateUtils.jumpToTheStep(scope.editCoverageStep);
            };

            return ctrl.create(scope);
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/directives/QuoteDetailsBox.js
// module id = 853
// module chunks = 0